<template>
  <v-btn :id="id" :class="btnClass" @click="action(actionParams)" :title="title" x-small icon><v-icon :class="icon"></v-icon></v-btn>
</template>

<style lang="scss">
@import "buttonComponent.scss";
</style>

<script type="text/javascript">
import Vue from "vue";

export default Vue.extend({
  props: ["icon", "action", "actionParams", "title", "btnClass"],

  data() {
    return {
      id: 0
    };
  },

  mounted() {
    let self = this;
    if (self.actionParams) {
      self.id = self.title + "-" + self.actionParams.id;
      //Permet de griser un bouton
      Vue.nextTick().then(function() {
        if (self.actionParams.disableButton) {
          for (let disableButton of self.actionParams.disableButton) {
            if (disableButton && disableButton.disabled) {
              document.getElementById(`#${disableButton.button}-${self.actionParams.id}`).setAttribute("disabled", true);
              //$(`#${disableButton.button}-${self.actionParams.id}`).prop("disabled", true);
            }
          }
        }
      });
    }
  }
});
</script>
